import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { injectState } from 'freactal'
import {
  Card,
  CardTitle,
  CardText,
  CardActions,
  Textfield,
} from 'react-mdl'
import Button from '../components/Button'

class SignIn extends Component {
  state = {
    email: '',
    password: '',
  }
  signIn = async () => {
    try {
      const { email, password } = this.state
      await this.props.effects.authenticate({ email, password })
      const { state: { returnTo = '/' } = {} } = this.props.location
      this.props.history.replace(returnTo)
    } catch (err) {
      this.setState({
        error: 'Signin failed!',
      })
    }
  }
  handleChangeEmail = ({ target }) => this.setState({ email: target.value })
  handleChangePassword = ({ target }) =>
    this.setState({ password: target.value })
  render() {
    const { email, password, error } = this.state
    return (
      <Card shadow={0} style={{ margin: 'auto' }}>
        <CardTitle>Sign In</CardTitle>
        <CardText>
          <Textfield
            label="Email"
            floatingLabel
            onChange={this.handleChangeEmail}
            value={email}
            type="email"
            required
          />
          <Textfield
            label="Password"
            floatingLabel
            onChange={this.handleChangePassword}
            value={password}
            type="password"
            required
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </CardText>
        <CardActions>
          <Button primary raised onClick={this.signIn}>Sign In</Button>
        </CardActions>
      </Card>
    )
  }
}

export default withRouter(injectState(SignIn))



// WEBPACK FOOTER //
// ./src/SignIn/index.js